import type { DirectiveBinding } from 'vue'
/**
 * 根据字符长度控制el-tooltip的显隐
 * 1.单行文本使用：需在对应组件定义moveTodisabled
 * 例：
 *  const moveTodisabled = ref({disabled: true})
 *  <el-tooltip
     :content="item.name"
     :disabled="moveTodisabled.disabled"
     >
      <div v-tooltip="moveTodisabled">{{ item.name }}</div>
   </el-tooltip>
 */

/**
    * 2.列表使用, 参数: list，index(当前索引)
  例：
   <el-option v-for="(item, index) in fileNameList" :key="item.id" :label="item.name" :value="item.name">
     <el-tooltip
       :content="item.name"
       :disabled="item.moveTodisabled"
       >
       <div v-tooltip:[index]="fileNameList" class="custom-dropdown-item">{{ item.name }}</div>
     </el-tooltip>
   </el-option>
    */

interface Actual {
  width: number
  element: HTMLSpanElement
}
interface HTMLElementPlus extends HTMLElement {
  _handler: () => void
  _handler2: () => void
  _ele: HTMLElementPlus
  _ele_temp: HTMLSpanElement | null
}

function getActualWidth(text: string, fontSize: string): Actual {
  const span: HTMLSpanElement = document.createElement('span')
  span.innerText = text
  span.style.cssText
    = 'visibility:hidden;position:absolute;z-index:-1;top:0;font-size:' + fontSize
  document.body.appendChild(span)
  const rect = span.getBoundingClientRect()
  // offsetWidth 是整数
  return { width: Math.round(rect.width), element: span }
}

function destoryEle(ele: HTMLSpanElement) {
  ele.parentNode?.removeChild(ele)
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('tooltip', {
    mounted(el: HTMLElementPlus, binding: DirectiveBinding) {
      const handler = () => {
        const index = Number(binding.arg)
        const fontSize = getComputedStyle(el, null).fontSize
        const { width, element }: Actual = getActualWidth(el.innerText, fontSize)
        el._ele_temp = element as HTMLSpanElement
        if (el.offsetWidth < width) {
          if (!isNaN(index)) {
            binding.value[index].moveTodisabled = false
          }
          else {
            binding.value.disabled = false
          }
        }
        else {
          if (!isNaN(index)) {
            binding.value[index].moveTodisabled = true
          }
          else {
            binding.value.disabled = true
          }
        }
      }

      const handle2 = () => {
        destoryEle(el._ele_temp as HTMLSpanElement)
        el._ele_temp = null
      }

      el._handler = handler
      el._handler2 = handle2
      el._ele = el
      el.addEventListener('mouseenter', handler)
      el.addEventListener('mouseout', handle2)
    },
    unmounted(el: HTMLElementPlus) {
      const { _ele } = el
      _ele.removeEventListener('mouseenter', _ele._handler)
      _ele.removeEventListener('mouseout', _ele._handler2)
    },
  })
})
